<template>
  <div class="tag-abs">
    <div class="tag-matrix-holder">
      <div
        v-if="matrixMode !== 'add' && matrixMode !== 'edit'"
        class="add-abs"
      >
        <div
          v-if="type === 'tags'"
          class="create-button"
          @click="handleManageGroups"
        >
          Manage Groups
        </div>
        <div
          v-if="type === 'tags'"
          class="create-button"
          @click="handleAddTag"
        >
          Create Tag
        </div>
        <div
          class="add-tag-button"
          @click="handleClose"
        >
          DONE
        </div>
      </div>

      <div
        v-if="matrixMode === 'show'"
        class="tag-matrix-options"
      >
        <div
            class="tag-matrix-titles-holder"
            v-if="type === 'tags' "
        >
          <TagMatrixTitle
            v-for="(data, index) in groupData"
            :key="index"
            :tab-index="index"
            :title="data.groupName"
            @click="handleSetIndex(index)"
          />
        </div>
<!--        <TagMatrixData
          v-if="selectedGroup !== null"
          :is-back="true"
          :tags="[selectedGroup]"
        />-->
        <div class="tag-matrix-data-holder">
          <TagMatrixData
            v-if="selectedGroup === null"
            :tags="getTagsInSelectedGroup()"
            :type="type"
          />
        </div>
      </div>
      <div
        v-show="getMatrixAddEdit"
        class="tag-matrix-add"
      >
        <TagManageOptions :mode="matrixMode" />
      </div>
    </div>
  </div>
</template>

<script>
import TagMatrixTitle from '@/components/rmt/tag_matrix/TagMatrixTitle';
import TagMatrixData from '@/components/rmt/tag_matrix/TagMatrixData';
import { useRMTStore } from '@/store/RMTStore';
import { mapStores } from 'pinia/dist/pinia';
import TagManageOptions from '@/components/rmt/tag_matrix/TagManageOptions';
import {useCollectionStore} from '@/store/CollectionStore';
import {usePermissionStore} from '@/store/PermissionStore';

export default {
  name: 'TagMatrix',
  components: { TagMatrixTitle, TagMatrixData, TagManageOptions },
  props: [
    'tagData',
    'tagTitles',
    'type'

  ],
  emits: [
    'hideMatrix'
  ],
  data () {
    return {};
  },
  computed: {
    ...mapStores(useRMTStore),
    matrixMode () {
      const RMTStore = useRMTStore();
      return RMTStore.matrixMode;
    },
    getMatrixAddEdit () {
      return this.RMTStore.matrixMode === 'add' || this.RMTStore.matrixMode === 'edit';
    },
    editTag () {
      const RMTStore = useRMTStore();
      return RMTStore.editTag;
    },
    groupData () {
      const RMTStore = useRMTStore();
      return RMTStore.groupData;
    },
    selectedGroup () {
      const RMTStore = useRMTStore();
      return RMTStore.selectedGroup;
    },
  },
  watch: {
    editTag () {
      this.getTagsInSelectedGroup();
    }
  },
  methods: {
    getTagsInSelectedGroup () {
      
      switch (this.$props.type) {
        case 'tags':
          // eslint-disable-next-line no-case-declarations
          const RMTStore = useRMTStore();
          return RMTStore.getTagsInSelectedGroup;
        case 'collections':
          // eslint-disable-next-line no-case-declarations
          const collectionStore = useCollectionStore();
          return collectionStore.collections;
        case 'permissions':
          // eslint-disable-next-line no-case-declarations
          const permissionStore = usePermissionStore();
          return permissionStore.permissionData;
      }
  
      
    },
    handleClose () {
      this.$emit('hideMatrix');
    },
    handleSetIndex (num) {
      if (this.selectedGroup !== null) {
        this.RMTStore.clearSelectedGroup();
      }
      this.RMTStore.selectedTagAddGroup = this.groupData[num];
      this.RMTStore.setSelectedTab(num);
    },
    handleAddTag () {
      this.RMTStore.manageGroupMode = false;
      this.RMTStore.resetCreateTag();
      this.RMTStore.matrixMode = 'add';
    },
    handleManageGroups () {
      this.RMTStore.manageGroupMode = true;
      this.RMTStore.resetCreateTag();
      this.RMTStore.matrixMode = 'add';
    }
  }
};
</script>

<style scoped>

.tag-abs {
  position: absolute;
  z-index: 900;
  pointer-events: none;
  display: flex;
  transform: translateX(-100%) translateY(50%);
  min-height: 400px;
  max-width: 400px;
}


.tag-matrix-holder {
/*  z-index: 100;*/
  width: 100%;
  min-height: 250px;
  min-width: 400px;
  background-color: white;
/*  border: 1px solid black;*/
  pointer-events: auto;
  -webkit-box-shadow: 6px 6px 17px -2px rgba(0, 0, 0, 0.18);
  -moz-box-shadow: 6px 6px 17px -2px rgba(0, 0, 0, 0.18);
  box-shadow: 6px 6px 17px -2px rgba(0, 0, 0, 0.18);
/*  transform: translateX(-105%) translateY(-60%);*/
}
.tag-matrix-data-holder {
  column-count: 2;
  column-gap: 0px;
  padding-bottom: 54px;
  height: 100%;
}
.tag-matrix-titles-holder {
  height: 62px;
  overflow-x: scroll;
  display: flex;
/*  flex-wrap: wrap;*/
}
.add-abs {
  position: absolute;
  padding-left: 20px;
  padding-right: 20px;
  justify-items: center;
  align-items: center;
  bottom: 0px;
  right: 0px;
  height: 70px;
  width: 100%;
/*  background-color: #9c9c9c;*/
  display: flex;
}
.add-tag-button {
  margin-left:auto;
/*  margin-right:10px;*/
  padding: 5px 10px;
  bottom:0;
  cursor: pointer;
  background-color: var(--nelson-green);
  color: white;
  height: 35px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 900;
  letter-spacing: 0.05em;
}
.tag-matrix-add {
  min-width: 400px;
  height: 400px;
}
.create-button {
  margin-right: 20px;
  font-weight: 700;
  font-size: .85em;
  display: flex;
  align-items: center;
  justify-content: center;
}



</style>